<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <ng-template #target></ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="color" (click)="cancel()">{{action1}}</button>
  <span class="spacer"></span>
  <button mat-button class="color" (click)="save()" [disabled]="saveButtonDisabledState()">{{action2}}</button>
</mat-dialog-actions>